

















































import {Component, Vue, Watch} from "vue-property-decorator";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import Tabs from "@/components/Tabs/Tabs.vue";
import Tab from "@/components/Tabs/Tab.vue";
import Form from "@/components/Form/Form.vue";
import Input from "@/components/Form/elements/Input.vue";
import {Action, Getter} from "vuex-class";
import IUser from "@/models/IUser";
import SubmitButton from "@/components/Form/elements/SubmitButton.vue";

const namespace = 'user';
const RESOURCE = 'user-profile'

@Component({
  components: {SubmitButton, Input, Form, Tab, Tabs, DefaultLayout}
})
export default class Profile extends Vue {
  public name: string = "Profile";

  @Action('loadUser', {namespace: namespace}) loadUser: any;
  @Action('updateItem', {namespace: namespace}) update: any;


  @Getter('getUser', {namespace: namespace}) user: any;
  @Getter('getValidationErrors', {namespace: namespace}) validationErrors: any;

  @Watch('user', {immediate: true, deep: true})
  private onUserChange(newVal: any) {
    // removed console_log
    if (this.user) {
      // removed console_log
      this.$nextTick(() => {

        let user: IUser = this.user;

        this.user_name = user.name;

      });

    }

  }


  private user_name: string = '';

  private password: string = '';
  private passwordConfirmation: string = '';

  private getValidationErrors(property: string) {

    if (this.validationErrors && this.validationErrors.hasOwnProperty(property)) {

      return this.validationErrors[property];

    }

    return '';

  }


  mounted() {

    this.loadUser();

  }

  private updateUserData(): void {

    this.update({
      resource: RESOURCE,
      data: {
        name: this.user_name,
      }
    });

  }

  private updatePassword(): void {

    this.update({
      resource: RESOURCE + '/password-change',
      data: {
        password: this.password,
        password_confirmation: this.passwordConfirmation
      }
    });

  }


}
